import { Button } from "@/components/ui/button";

import { UpgradeModal } from "./upgrade-modal";

type UpgradeCardProps = {
  title: string;
  description: string;
  buttonText: string;
};

export function UpgradeCard({
  title,
  description,
  buttonText,
}: UpgradeCardProps) {
  return (
    <div className="rounded-2xl border border-border bg-gradient-to-br from-primary/90 to-primary p-1">
      <div className="h-full rounded-[calc(var(--radius)+2px)] border border-primary/30 bg-[#53389E] p-4">
        <p className="mb-4 text-lg font-medium text-white">{title}</p>
        <p className="text-md mb-6 text-[#E9D7FE]">{description}</p>
        <UpgradeModal>
          <Button variant="outline">{buttonText}</Button>
        </UpgradeModal>
      </div>
    </div>
  );
}
